/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTaskListForm } from '../models/CreateTaskListForm';
import type { EditTaskListForm } from '../models/EditTaskListForm';
import type { ModifyTaskInListForm } from '../models/ModifyTaskInListForm';
import type { TaskList } from '../models/TaskList';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskListsService {
    /**
     * Find a task list by id
     * @returns TaskList Task
     * @throws ApiError
     */
    public static findTaskList({
        id,
    }: {
        /**
         * Id of the task list
         */
        id: number,
    }): CancelablePromise<TaskList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/projects/tasks/list/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the task list.`,
            },
        });
    }
    /**
     * Edit a task list
     * @returns TaskList Edited task list
     * @throws ApiError
     */
    public static editTaskList({
        id,
        requestBody,
    }: {
        /**
         * Id of the task list
         */
        id: number,
        /**
         *   The fields to be edited.
         * If a field is omitted, it will not be edited. If a field is set to null,
         * however, it will be - if possible - set to null.
         *
         * Endpoint can be typically used to set a task list to completed (by only
         * providing this field).
         *
         */
        requestBody: EditTaskListForm,
    }): CancelablePromise<TaskList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/projects/tasks/list/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the task list.`,
            },
        });
    }
    /**
     * Delete a task list
     * @returns any Task list has been deleted.
     * @throws ApiError
     */
    public static deleteTaskList({
        id,
    }: {
        /**
         * Id of the task list
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/projects/tasks/list/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the task list.`,
            },
        });
    }
    /**
     * Lists task lists
     * @returns TaskList Task lists
     * @throws ApiError
     */
    public static listTaskLists(): CancelablePromise<Array<TaskList>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/projects/tasks/list',
            errors: {
                403: `The user's team has no access to this feature.`,
            },
        });
    }
    /**
     * Create a new task list
     * @returns TaskList Created task list
     * @throws ApiError
     */
    public static createTaskList({
        requestBody,
    }: {
        /**
         *   The new task list to be created. Only the `name` and `tasks` fields
         * are required. The `tasks` set can be empty however.
         *
         */
        requestBody: CreateTaskListForm,
    }): CancelablePromise<TaskList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/projects/tasks/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request body is invalid: Both required fields could be missing or the name could be blank.`,
                403: `The user's team has no access to this feature.`,
            },
        });
    }
    /**
     * Add a task to a list
     * Adds a task to a task list.
     *
     * If the task is already added to another task list, it will be removed
     * from this list and added to the specified list.
     *
     * @returns TaskList Edited task list
     * @throws ApiError
     */
    public static addTaskToTaskList({
        id,
        requestBody,
    }: {
        /**
         * Id of the task list
         */
        id: number,
        /**
         * The id of the task that should be added to the list.
         */
        requestBody: ModifyTaskInListForm,
    }): CancelablePromise<TaskList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/projects/tasks/list/{id}/tasks',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the task list.`,
            },
        });
    }
    /**
     * Remove a task from a list
     * Removes a task from a task list.
     *
     * @returns TaskList Edited task list
     * @throws ApiError
     */
    public static removeTaskFromTaskList({
        id,
        requestBody,
    }: {
        /**
         * Id of the task list
         */
        id: number,
        /**
         * The id of the task that should be removed from the list.
         */
        requestBody: ModifyTaskInListForm,
    }): CancelablePromise<TaskList> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/projects/tasks/list/{id}/tasks',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `The user's team has no access to this feature or the user has no access to the task list.`,
            },
        });
    }
}
